/** Tema claro/escuro/automático (classe .dark no <html>, salvo no localStorage). */
import { useSyncExternalStore } from "react";

export type ThemePref = "light" | "dark" | "system";
const KEY = "tenanci.theme";
const listeners = new Set<() => void>();

function read(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark" || v === "system") return v;
  } catch {
    /* ignora */
  }
  return "system";
}

let pref: ThemePref = typeof window === "undefined" ? "system" : read();

const media = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null);

export function applyTheme() {
  const dark = pref === "dark" || (pref === "system" && !!media()?.matches);
  document.documentElement.classList.toggle("dark", dark);
}

export function setTheme(next: ThemePref) {
  pref = next;
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* ignora */
  }
  applyTheme();
  listeners.forEach((l) => l());
}

/** Acompanha a preferência do sistema quando o tema é "automático". */
export function watchSystemTheme() {
  const m = media();
  const onChange = () => pref === "system" && applyTheme();
  m?.addEventListener?.("change", onChange);
  return () => m?.removeEventListener?.("change", onChange);
}

export function useTheme() {
  const value = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => pref,
    () => pref,
  );
  return { theme: value, setTheme };
}
